import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { pageLeftThunk } from '@redux/analytics/analyticsThunks';
import { PageType } from '@redux/analytics/analyticsTypes';
import { DevicePaneV2 } from 'containers/Account/components/DualPane/Panes/DevicePaneV2/DevicePaneV2';
import { SuccessPane } from 'containers/Account/components/DualPane/Panes/SuccessPane/SuccessPane';
import { DualPaneV2 } from 'containers/Account/components/DualPaneV2/DualPaneV2';

type Props = ConnectedProps<typeof connectRedux>;

const SuccessAuth: React.FC<Props> = ({ pageLeft }) => {
  return (
    <DualPaneV2
      pageLeft={pageLeft}
      pageType={PageType.AUTH_SUCCESS}
      leftPane={() => <SuccessPane description="Now download the Cairns Companion app on your phone to finish the setup for your device." />}
      rightPane={<DevicePaneV2 />}
    />
  );
};

const connectRedux = connect(
  () => {
    return {};
  },
  (dispatch: Function) => ({
    pageLeft: async (pageType: PageType) => {
      return dispatch(pageLeftThunk(pageType));
    }
  })
);

export default compose(connectRedux)(SuccessAuth);
